import React, { useCallback, useEffect } from "react";
import { CheckBoxInput, SelectForm } from "../../Buttons";
import TextInputModal from "../../TextInputModal";
import ShippmentTable from "./editModal/Shippment/ShippmentTable";
import { AlertError, AlertSuccess } from "../../Alerts";
import styled from "styled-components";
import RowsInShipment from "./editModal/RowsInShipment";
import RowsInShipmentService from "./editModal/RowsInShipmentService";
import ShipmentAdditionalServices from "./ShipmentAdditionalServices";
import { ButtonSecondary } from "../../../common";
import DalineSaskaita from "./editModal/invoice/PopoverInvoiceButton";
import { show_parcels } from "../../../../helpers/OrdersFunctionsGlobal";
import { useDispatch, useSelector } from "react-redux";
import {
  setCountriesOptions,
  setParcelTerminalsOptions,
  setPickupAddressesOptions,
} from "../../../../redux/Actions/options_action";
import { shipmentTypeRules } from "../../../../helpers/ShipmentRules";
import SelectParcelTerminalInput from "../../../globals/SelectParcelTerminalInput";

// record_id - order_id/fake_order_id
function ShippingComponent({
  shop_identifier,
  disabled = false,
  order_type,
  record_id = null,
  delivery,
  mode,
  shipping_address_edit,
  terminalSelected,
  handleChangeText,
  order_rows,
  shipments,
  handleCheckBoxOrdersSelected,
  variables,
  onChangeCheckBoxDelivery,
  createShipping,
  errors,
  selectedOrderRows,
  skip_labels,
  setSkipLabels,
  order,
  user,
  selectedCarrier,
  onChangeCarrier,
  form_type = "Order",
}) {
  const dispatch = useDispatch();
  const { countries, pickup_addresses } = useSelector((state) => state.options);
  useEffect(() => {
    dispatch(setCountriesOptions());
    dispatch(setParcelTerminalsOptions());
    dispatch(setPickupAddressesOptions());
  }, []);

  const itsTypeStore = order_type == "at_the_store";

  const shipment_rule = shipmentTypeRules(order_type);

  const onChangeParcelTerminal = useCallback(
    (value) =>
      handleChangeText({
        target: { name: "terminalSelected", value },
      }),
    []
  );

  const hasCarryingService = order_rows?.some((row) =>
    ["Uznešanas", "kandeteenus", "užnešimas", "81", "101", "90"].some(
      (keyword) => row.product_name?.includes(keyword)
    )
  );

  return (
    <>
      {!disabled && (
        <>
          <div className="col-12 bg-silver pt-3 mb-4">
            <AlertSuccess alertId={"orderShippment-s"} />
            <AlertError alertId={"orderShippment-e"} />
            {shipment_rule.deliveries.map(({ value, label }) => {
              return (
                <CheckBoxInput
                  key={value}
                  name={value}
                  text={label}
                  checked={delivery == value}
                  onChange={(e) => onChangeCheckBoxDelivery(e)}
                />
              );
            })}
            {hasCarryingService && (
              <div className="col-12 row">
                {shipping_address_edit?.country_id === 122 && (
                  <div className="col-6">
                    <CheckBoxInput
                      name={"siuntu_pilotai"}
                      text={"Siuntų pilotai"}
                      type="radio"
                      checked={selectedCarrier === "siuntu_pilotai"}
                      onChange={() => onChangeCarrier("siuntu_pilotai")}
                    />
                  </div>
                )}
                {shipping_address_edit?.country_id === 115 && (
                  <div className="col-6">
                    <CheckBoxInput
                      name={"avector"}
                      text={"Avector"}
                      type="radio"
                      checked={selectedCarrier === "avector"}
                      onChange={() => onChangeCarrier("avector")}
                    />
                  </div>
                )}
                {shipping_address_edit?.country_id === 51 && (
                  <div className="col-6">
                    <CheckBoxInput
                      name={"adduco"}
                      text={"Adduco"}
                      type="radio"
                      checked={selectedCarrier === "adduco"}
                      onChange={() => onChangeCarrier("adduco")}
                    />
                  </div>
                )}
                <div className="col-6">
                  <CheckBoxInput
                    name={"sendDirectly"}
                    text={"Siųsti tiesiogiai"}
                    type="radio"
                    checked={selectedCarrier === "sendDirectly"}
                    onChange={() => onChangeCarrier("sendDirectly")}
                  />
                </div>
              </div>
            )}
            <Divs>
              <TextInputModal
                required="true"
                text="Recipient"
                placeholder="Enter"
                name="firstname"
                value={shipping_address_edit.firstname}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <TextInputModal
                required="true"
                text="Contact person"
                placeholder="Enter"
                name="lastname"
                value={shipping_address_edit.lastname}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <SelectForm
                required={true}
                options={countries?.map((e) => ({
                  value: e.id,
                  label: e.en_name,
                }))}
                placeholder="Country"
                onlyPlaceholder="Choose"
                value={shipping_address_edit.country_id}
                onChange={(value) => {
                  handleChangeText(
                    {
                      target: { name: "country_id", value },
                    },
                    "shipping_address_edit"
                  );
                  handleChangeText({
                    target: { name: "terminalSelected", value: null },
                  });
                }}
              />
            </Divs>
            <Divs>
              <TextInputModal
                required="true"
                text="Address"
                placeholder="Enter"
                name="street"
                value={shipping_address_edit.street}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            {show_parcels(order_type, delivery) && (
              <Divs>
                <SelectParcelTerminalInput
                  label="Parcel terminal"
                  value={terminalSelected}
                  shipment_type={order_type}
                  delivery={delivery}
                  country_id={shipping_address_edit.country_id}
                  onChange={onChangeParcelTerminal}
                />
              </Divs>
            )}
            <Divs>
              <TextInputModal
                required="true"
                text="City"
                placeholder="Enter"
                name="city"
                value={shipping_address_edit.city}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <TextInputModal
                required="true"
                text="Postal code"
                placeholder="Enter"
                name="postal_code"
                value={shipping_address_edit.postal_code}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <TextInputModal
                text="Phone"
                placeholder="Enter"
                name="phone"
                value={shipping_address_edit.phone}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <TextInputModal
                text="Email"
                placeholder="Enter"
                name="other"
                value={shipping_address_edit.other}
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <Divs>
              <TextInputModal
                text="Note from client"
                placeholder="Enter"
                value={shipping_address_edit.comment}
                name="comment"
                onChange={(e) => handleChangeText(e, "shipping_address_edit")}
              />
            </Divs>
            <SelectForm
              options={
                shop_identifier == "TCH"
                  ? pickup_addresses.filter(({ technorama }) => technorama)
                  : pickup_addresses
              }
              placeholder={itsTypeStore ? "Delivery from" : "Supplier"}
              onlyPlaceholder="Choose"
              selector="suppliers"
              value={variables.suppliers}
              onChange={(value) =>
                handleChangeText({
                  target: {
                    name: "suppliers",
                    value,
                  },
                })
              }
              error={
                errors.pickup_address &&
                errors.pickup_address.map((item) => `${item} `)
              }
            />
            <Divs className="border-top border-bottom mt-2">
              <div className="text-bold pt-2 d-flex justify-content-between">
                <span>Order goods</span>
              </div>
              {mode == "Servisas" ? (
                <RowsInShipmentService
                  mode={mode}
                  order_rows={order_rows}
                  selectedOrderRows={selectedOrderRows}
                  handleCheckBoxOrdersSelected={handleCheckBoxOrdersSelected}
                />
              ) : (
                <RowsInShipment order_rows={order_rows} order_type={order_type} />
              )}
            </Divs>
            <ShipmentAdditionalServices
              order={order}
              user={user}
              order_rows={order_rows}
              createShipping={createShipping}
              order_type={order_type}
              delivery={delivery}
              variables={variables}
              handleChangeText={handleChangeText}
              errors={errors}
              country_id={shipping_address_edit.country_id}
              skip_labels={skip_labels}
              setSkipLabels={setSkipLabels}
              address={{
                ...shipping_address_edit,
                parcel_terminal_id: terminalSelected
              }}
            />
            <div className="d-flex justify-content-between align-items-center pb-2 ">
              <div>{mode !== "Servisas" && <DalineSaskaita />}</div>
              <ButtonSecondary
                width={150}
                loading={variables.shipping_loading}
                onClick={() => createShipping()}
              >
                {itsTypeStore ? "Create a pickup" : "Create a shipment"}
              </ButtonSecondary>
            </div>
          </div>
        </>
      )}
      <table className="table mb-4">
        <tbody>
          {shipments.map((shipment) => (
            <ShippmentTable
              key={shipment.id}
              record_id={record_id}
              mode={mode}
              item={shipment}
              orderId={record_id}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}

const Divs = styled.div`
  display: block;
  color: #000000;
  font-size: 15px;
  font-weight: 400;
  & .text-bold {
    font-size: 14px;
    line-height: 20px;
    color: #030303;
    font-weight: 600;
  }
  & .residuesItem {
    font-size: 0.8rem;
    word-wrap: break-word;
  }

  & .orange_color {
    color: #f7951e;
  }
  & .addDoc {
    margin-top: 5px;
    color: #f7951e;
    &:hover {
      color: #bd6903;
      border-bottom: 1px solid #f7951e;
      cursor: pointer;
    }
  }
  & .input_text {
    right: 7%;
    top: 50%;
    font-weight: bold;
    text-transform: uppercase;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
`;

export default ShippingComponent;
